// Transporter IDs for Part-A e-way bills. One list for the admin reference page and the customer booking page.
export const TRANSPORTER_IDS = [
  { carrier: "Sendtoo (Own Network)", id: "37AANCC5387L1ZV" },
  { carrier: "Delhivery", id: "06AAPCS9575E1ZR" },
  { carrier: "XB", id: "27AAGCB3904P2ZC" },
  { carrier: "DTDC", id: "88AAACD8017H1ZX" },
  { carrier: "Bluedart", id: "27AAACB044L1ZS" },
  { carrier: "DP World", id: "88AADCD1983D1ZS" },
  { carrier: "Movin", id: "88AAFCI7460Q1ZW" },
  { carrier: "ECOM", id: "03AADCE1344F1ZA" },
  { carrier: "Ekart LTL", id: "07AADCI8374D2ZH" },
  { carrier: "TCI Express", id: "06AADCT0663J4Z9" },
];

// The two networks a customer can book on from the portal.
export const CUSTOMER_NETWORKS = [
  { value: "DELHIVERY", label: "Delhivery", sub: "Third-party logistics, all India", id: "06AAPCS9575E1ZR" },
  { value: "SENDTOO", label: "Capexlite (Sendtoo own network)", sub: "Within South India", id: "37AANCC5387L1ZV" },
];
